/* ---------------------------------------------------------------------------
   Renders a CMS-authored custom page at /p/:slug from content.pages. Unknown
   slugs redirect home. Uses the shared <Blocks> renderer so custom pages share
   the site's look. Wrapped in the public chrome by AppRoutes/App.
--------------------------------------------------------------------------- */
import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useContent } from "../data/content";
import Blocks from "../blocks/Blocks";

export default function CustomPage() {
  const { slug } = useParams();
  const { content, loading } = useContent();
  const pages = Array.isArray(content?.pages) ? content.pages : [];
  const page = pages.find((p) => p.slug === slug);

  useEffect(() => {
    if (page?.title) document.title = `${page.title} · SGADI`;
  }, [page]);

  // Wait for content before deciding a slug is missing (avoids a flash-redirect).
  if (loading) return <div className="section"><div className="container" /></div>;
  if (!page) return <Navigate to="/home" replace />;

  return (
    <main className="custom-page">
      <Blocks blocks={page.blocks} />
    </main>
  );
}
